import { render, staticRenderFns } from "./TheMainSideNav.vue?vue&type=template&id=20a8e75f&scoped=true&"
import script from "./TheMainSideNav.vue?vue&type=script&lang=js&"
export * from "./TheMainSideNav.vue?vue&type=script&lang=js&"
import style0 from "./TheMainSideNav.vue?vue&type=style&index=0&id=20a8e75f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a8e75f",
  null
  
)

export default component.exports